exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-pc-components-organisms-mobile-MobileEditorPreviewSlider-___MobileEditorPreviewSlider__previewItem___3n1oc {\n  margin: 0 -4px;\n  outline: none;\n  transition: -webkit-transform 0.5s ease 0s;\n  -webkit-transition: -webkit-transform 0.5s ease 0s;\n  transition: transform 0.5s ease 0s;\n  transition: transform 0.5s ease 0s, -webkit-transform 0.5s ease 0s;\n}\n\n.src-pc-components-organisms-mobile-MobileEditorPreviewSlider-___MobileEditorPreviewSlider__nonactive___2xSS9 {\n  -webkit-transform: scale(0.75);\n          transform: scale(0.75);\n}\n", ""]);

// exports
exports.locals = {
	"previewItem": "src-pc-components-organisms-mobile-MobileEditorPreviewSlider-___MobileEditorPreviewSlider__previewItem___3n1oc",
	"nonactive": "src-pc-components-organisms-mobile-MobileEditorPreviewSlider-___MobileEditorPreviewSlider__nonactive___2xSS9"
};